/** Scrolls the least distance that brings `element` inside its scroll margins; does nothing when it is already fully inside. */
export function scrollIntoClearView(element: HTMLElement | null) {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  element?.scrollIntoView({ block: "nearest", behavior: reduceMotion ? "auto" : "smooth" });
}
